module.exports = "/images/logo_01.png?2ca887c62cc3561625a8eed3131b6c25";